import React from 'react'
import './table.css'
import type { IDataTableProps } from 'react-data-table-component';
import DataTable from 'react-data-table-component';

function CustomDataTable<T>(props: IDataTableProps<T>): React.ReactElement {
  const CustomLoader = (): React.ReactElement =>  (
    <div style={{ padding: '24px' }}>
      <div className='flex justify-center items-center relative top-[50%]'><span className="loading loading-spinner text-primary"></span></div>
    </div>
  );

  return (
    <DataTable
      {...props}
      sortIcon={<div className='sort-arrow'><svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 9 9" fill="none">
        <path d="M4.02975 1.81922L2.31673 0.106198C2.28441 0.0738769 2.24286 0.046173 2.19668 0.0277038C2.19207 0.0277038 2.18745 0.0277038 2.18283 0.0230865C2.14589 0.00923459 2.10895 0 2.0674 0C1.97505 0 1.88732 0.0369385 1.82268 0.101581L0.100426 1.81922C-0.0334755 1.95312 -0.0334755 2.17475 0.100426 2.30865C0.234328 2.44255 0.455959 2.44255 0.589861 2.30865L1.7211 1.17741V8.65745C1.7211 8.84676 1.87809 9.00375 2.0674 9.00375C2.25671 9.00375 2.4137 8.84676 2.4137 8.65745V1.18203L3.54032 2.30865C3.60957 2.37791 3.6973 2.41023 3.78503 2.41023C3.87276 2.41023 3.96049 2.37791 4.02975 2.30865C4.16365 2.17475 4.16365 1.95774 4.02975 1.81922Z" fill="#77787B" />
        <path d="M8.89938 6.69509C8.76548 6.56119 8.54385 6.56119 8.40995 6.69509L7.27871 7.82633V0.346298C7.27871 0.156988 7.12172 0 6.93241 0C6.7431 0 6.58611 0.156988 6.58611 0.346298V7.82171L5.45949 6.69509C5.32559 6.56119 5.10396 6.56119 4.97006 6.69509C4.83615 6.82899 4.83615 7.05062 4.97006 7.18453L6.68308 8.89755C6.7154 8.92987 6.75695 8.95757 6.80313 8.97604C6.80774 8.97604 6.81236 8.97604 6.81698 8.98066C6.85392 8.99451 6.89547 9.00375 6.93703 9.00375C7.02937 9.00375 7.1171 8.96681 7.18174 8.90216L8.89938 7.18453C9.03328 7.04601 9.03328 6.82899 8.89938 6.69509Z" fill="#DFE0E0" />
      </svg></div>}
      progressComponent={<CustomLoader />}
    />
  )
}

export default CustomDataTable